import React from 'react';
import classNames from 'classnames';
import get from 'lodash.get';
import { package as PackagePropType } from 'lib/CustomPropTypes';

import Promo3Card from './components/Promo3Card';

const Promo3Panel = (props) => {
  const {
    content: {
      id,
      items,
      metadata,
      packageIndex,
    } = {},
  } = props;
  const globalShowTease = get(metadata, 'showTeaseImage', true);

  return (
    <section
      className={classNames(
        'pkg promo3Panel',
        `pkg-index-${packageIndex + 1}`,
      )}
      data-packageid={id}
    >
      {items.map((item) => {
        if (!item) { return null; }

        const contentId = get(item, 'id');

        const dek = get(item, ['computedValues', 'dek'], null);
        const headline = get(item, ['computedValues', 'headline'], null);
        const image = get(item, ['computedValues', 'teaseImage', 'url', 'primary'], null);
        const url = get(item, ['computedValues', 'url']);

        const buttonTitle = get(item, ['metadata', 'ctaText'], null);
        const buttonUrl = get(item, ['metadata', 'ctaUrl'], url);
        const showTeaseImage = get(item, ['metadata', 'showTeaseImage'], globalShowTease);

        return (
          <Promo3Card
            buttonTitle={buttonTitle}
            buttonUrl={buttonUrl}
            contentId={contentId}
            data-test="promo-three-panel__card"
            dek={dek}
            headline={headline}
            hideTeaseImage={!showTeaseImage}
            key={headline}
            teaseImage={image}
          />
        );
      })}
    </section>
  );
};

Promo3Panel.propTypes = {
  content: PackagePropType.isRequired,
};

Promo3Panel.defaultProps = {};

export default Promo3Panel;
